import React from "react";
import { Link } from "react-router-dom";
import localLogo from "../../assets/logo.png";
import "./auth.css";

const defaultFeatures = [
  { icon: "fa-shield-halved", text: "Bank-grade security" },
  { icon: "fa-bolt", text: "Instant transfers" },
  { icon: "fa-headset", text: "24/7 support" },
];

const AuthLayout = ({
  company,
  wide = false,
  brandHeading = "Bank smarter, live better",
  brandSubheading = "Send money, pay bills, buy airtime and manage your wallet — all from one secure dashboard.",
  brandFeatures = defaultFeatures,
  children,
}) => {
  const logo = /*company?.logo ||*/ localLogo;
  const companyName = company?.company_name;

  return (
    <div className="auth-shell">
      <div className={`auth-shell-inner${wide ? " auth-shell-wide" : ""}`}>
        <aside className="auth-brand-panel d-none d-lg-flex">
          <div className="auth-brand-content">
            <Link to="/" className="auth-brand-logo">
              <img src={logo} alt={companyName || "Logo"} />
            </Link>

            <div className="auth-brand-copy">
              <h2>{brandHeading}</h2>
              <p>{brandSubheading}</p>
            </div>

            <ul className="auth-brand-features">
              {brandFeatures.map((feature) => (
                <li key={feature.text}>
                  <span className={`fas ${feature.icon}`}></span>
                  {feature.text}
                </li>
              ))}
            </ul>

            {(companyName || company?.address) && (
              <p className="auth-brand-footer">
                {companyName}
                {companyName && company?.address ? " · " : ""}
                {company?.address}
              </p>
            )}
          </div>
          <div className="auth-brand-shape auth-brand-shape-1"></div>
          <div className="auth-brand-shape auth-brand-shape-2"></div>
        </aside>

        <section className="auth-form-panel">
          <div className="auth-form-panel-inner">
            <Link to="/" className="auth-mobile-logo d-lg-none">
              <img src={logo} alt={companyName || "Logo"} />
              {companyName && <span>{companyName}</span>}
            </Link>
            {children}
          </div>
        </section>
      </div>
    </div>
  );
};

export default AuthLayout;
